import { render, staticRenderFns } from "./CustomerLandingPage.vue?vue&type=template&id=bebd1bb2&scoped=true&"
import script from "./CustomerLandingPage.vue?vue&type=script&lang=js&"
export * from "./CustomerLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLandingPage.vue?vue&type=style&index=0&id=bebd1bb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebd1bb2",
  null
  
)

export default component.exports